<template>
    <vx-dropdown teleport
        placement="right">
        <vx-button color="muted"
            :outline="true"
            data-test="campaign-dropdown"
            aria-label="Campaign actions">
            <font-awesome-icon fixedWidth :icon="faEllipsis"></font-awesome-icon>
        </vx-button>
        <template v-slot:items>
            <router-dropdown-item :to="{ name: 'campaigns.contacts', params: { id: props.campaign.id } }">
                Contacts
                <font-awesome-icon widthAuto :icon="faUserGroup" />
            </router-dropdown-item>
            <router-dropdown-item :to="{ name: 'campaigns.new', query: { duplicate_from_id: props.campaign.id } }"
                :disabled="teamStatus !== 'active'"
                data-test="copy">
                Duplicate
                <font-awesome-icon widthAuto :icon="faCopy" />
            </router-dropdown-item>

            <vx-dropdown-item :disabled="teamStatus !== 'active'"
                data-test="delete"
                @click="destroy()">
                Delete
                <font-awesome-icon widthAuto :icon="faTrash" />
            </vx-dropdown-item>
        </template>
    </vx-dropdown>
</template>

<script setup>
import { VxButton, VxDropdown, VxDropdownItem, VxSwal } from '@voxie/frontend-components';
import { faEllipsis, faCopy, faTrash, faUserGroup } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { campaignsClient } from '~/services';
import { throwSwalRequestError } from '~/utils/request';
import RouterDropdownItem from '~/components/general/RouterDropdownItem.vue';

const teamStatus = Spark.state.currentTeam.status;

const props = defineProps({
    campaign: {
        type: Object,
        required: true,
    },
});

const emit = defineEmits(["deleted"]);

const destroy = () => {
    VxSwal.confirmation(
        'Delete Campaign',
        "Are you sure? This campaign and its messages will be deleted. There is no undo.",
        'danger',
        () => campaignsClient
            .campaignDelete(props.campaign.team_id, props.campaign.id)
            .then(() => emit("deleted", props.campaign.id))
            .catch(throwSwalRequestError)
    );
};

</script>
